import bgNeural from "../images/background/neural-thing.png";
import bgNeural2 from "../images/background/neural-thing2.png";
import bgFlat from "../images/background/ft-general.svg";

const emptyBackground = {
    background: "radial-gradient(58.98% 58.98% at 50% 46.78%, #5F73CA 0%, #2F438F 100%)",
    backgroundPosition: "center center"
};

const loginBackground = {
    background: "url(" + bgNeural + ") repeat, radial-gradient(58.98% 58.98% at 50% 46.78%, #5F73CA 0%, #2F438F 100%)",
    //background: "url(" + bgNeural + ") repeat, radial-gradient(65.33% 65.33% at 48.72% 46.48%, #C4CFFF 0%, #869CF1 100%)",
    backgroundPosition: "center center"
};

const modulesBackground = {
    background: "url(" + bgNeural2 + ") repeat, radial-gradient(58.98% 58.98% at 50% 46.78%, #5F73CA 0%, #2F438F 100%)",
    //background: "url(" + bgNeural + ") repeat, radial-gradient(65.33% 65.33% at 48.72% 46.48%, #C4CFFF 0%, #869CF1 100%)",
    backgroundPosition: "center center"
};

const flatBackground = {
    background: "url(" + bgFlat + ") ",
    backgroundPosition: "center",
    width: "445px",
    height: "440px"
};

const iconStyle = {
    width: "45px",
    height: "40px",
}

export const cons = {
    loginBackground,
    modulesBackground,
    iconStyle,
    flatBackground,
    emptyBackground
}